import { WAT_TIME_ZONE, type WorkflowItem } from '#models';

export function createdTimestamp(item: Pick<WorkflowItem, 'createdDate'>): number | null {
  return parseTimestamp(item.createdDate);
}

export function completedTimestamp(item: Pick<WorkflowItem, 'runCompletedAt'>): number | null {
  return parseTimestamp(item.runCompletedAt);
}

function parseTimestamp(value: string | null | undefined): number | null {
  const raw = value?.trim();
  if (!raw || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/.test(raw)) {
    return null;
  }
  const day = Date.parse(`${raw.slice(0, 10)}T00:00:00Z`);
  if (!Number.isFinite(day) || new Date(day).toISOString().slice(0, 10) !== raw.slice(0, 10)
    || Number(raw.slice(11, 13)) > 23) {
    return null;
  }
  // SQL datetime2 values without an offset represent UTC, not the browser's local zone.
  const timestamp = Date.parse(/(?:Z|[+-]\d{2}:\d{2})$/.test(raw) ? raw : `${raw}Z`);
  return Number.isFinite(timestamp) ? timestamp : null;
}

/** WAT creation day used by filters, independently of the card's run-for date. */
export function createdDate(item: Pick<WorkflowItem, 'createdDate'>): string | null {
  return watCalendarDate(item.createdDate);
}

export function watCalendarDate(value: string | null | undefined): string | null {
  const timestamp = parseTimestamp(value);
  return timestamp === null ? null : new Intl.DateTimeFormat('en-CA', {
    year: 'numeric', month: '2-digit', day: '2-digit', timeZone: WAT_TIME_ZONE,
  }).format(timestamp);
}

export function reportDate(item: Pick<WorkflowItem, 'runForDate'>): string | null {
  const raw = item.runForDate?.trim();
  if (!raw || !/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;
  const timestamp = Date.parse(`${raw}T00:00:00Z`);
  return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === raw ? raw : null;
}
